export const cloudinary_upload_preset = 'bd7he0h1';

export const cloudinary_cloud = 'dcwb2b0fl';
